import { environment } from '@/environment.ts';
import stageConfig from './stage.json';
import prodConfig from './prod.json';

type BaseFinanceSettingTemplate = {
    billingText: string | null;
    creditorOrganizationId: number | '$TARGET_ORG';
    debtorOrganizationId: number | '$TARGET_ORG';
};

export type FinanceSettingTemplate =
    | (BaseFinanceSettingTemplate & {
          billingMethod: 'INVOICE' | 'CREDIT_NOTE';
          paymentTermId: number;
      })
    | (BaseFinanceSettingTemplate & {
          billingMethod: 'PARTNER_INVOICE';
          paymentTermId: null;
      });

export interface BulkPositionConfig {
    platformOrganizationId: number;
    marketCode: string;
    validFrom: string;
    validTo: string;
    active: boolean;
    note: string;
    businessCase: {
        productType: string;
        pricingStrategy: string;
        isStandalone: boolean;
    };
    financeSettingsTemplate: FinanceSettingTemplate[];
}

const isProduction = environment.SFLX_ENVIRONMENT === 'production';

export const bulkPositionConfig: BulkPositionConfig = isProduction
    ? (prodConfig as unknown as BulkPositionConfig)
    : (stageConfig as unknown as BulkPositionConfig);
